import { createContext } from "react";

const MenuContext = createContext();
MenuContext.displayName = "MenuContext";

export default MenuContext;
